import {MathJax, MathJaxContext} from "better-react-mathjax";
import {isNullOrUndefined} from "../../../services/Validator";

export default function LevelAExampleExplanationText({explanation}) {
    // Used in LevelAExampleQuestion to display question
    // text in LateX

    // BUILD
    if (isNullOrUndefined(explanation))
        return null
    // ---- Case : Explanation not null
    const hasFraction = explanation.includes("\\frac");
    const leadingClass = hasFraction ? "leading-loose" : "leading-relaxed";
    return (
        <div className={"w-full mt-[12px]"}>
            <MathJaxContext>
                <MathJax inline dynamic>
                    <span className={`whitespace-pre-line font-semibold text-white text-[18px] ${leadingClass}`}>
                        {explanation}
                    </span>
                </MathJax>
            </MathJaxContext>
        </div>
    );
}